import { resolveVersion, versions } from 'utils/versioning';

const globalRelatedAppName = resolveVersion({
  [versions.alpha]: 'Alpha Shredding Group',
  [versions.global]: 'Global West',
  [versions.west]: 'Global Portal',
});

export { globalRelatedAppName };
